module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/expand-4288aaa6857f565440459dc4ab42b36b.png";